export const SET_MEDIA = "SET_MEDIA";
export const MEDIA_LOADING = "MEDIA_LOADING";
export const SET_MEDIA_LIKE = "SET_MEDIA_LIKE";
export const INCREASE_MEDIA_COUNTER = "INCREASE_MEDIA_COUNTER";
export const SET_MEDIA_CATEGORIES = "SET_MEDIA_CATEGORIES";
export const SET_SELECTED_MEDIA_ENTRY = "SET_SELECTED_MEDIA_ENTRY";